<template>
  <v-card fill-height>
  <v-layout row wrap>
    <v-flex md12>
      <v-tabs
        color="white"
        light
        name="rbTabPanel"
        v-model="tab2"
        slider-color="#8ACAC1"
        @change="onChangeTab"
        v-if="tableData != null"
        class="activetab"
      >
        <v-tab href="#tabAktiva">{{'TAB_ROHBILANZ_AKTIVA' | translate}}</v-tab>
        <v-tab href="#tabPASSIVA">{{'TAB_ROHBILANZ_PASSIVA' | translate}}</v-tab>
        <v-tab href="#tabGUV">{{'TAB_ROHBILANZ_GUV' | translate}}</v-tab>
        <v-tab href="#tabSonstige">{{'TAB_ROHBILANZ_SONSTIGE' | translate}}</v-tab>
        <v-tab-item value="tabAktiva">
          <StrukturBilanzTable configSuffix="RB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabAktiva" :data="tableData" tableName="aktiva"
                               :RowBKGFromSource="true"
                               edoClassName="rb"></StrukturBilanzTable>
        </v-tab-item>
        <v-tab-item value="tabPASSIVA">
          <StrukturBilanzTable configSuffix="RB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabPASSIVA" :data="tableData" tableName="passiva"
                               :RowBKGFromSource="true"
                               edoClassName="rb"></StrukturBilanzTable>
        </v-tab-item>
        <v-tab-item value="tabGUV">
          <StrukturBilanzTable configSuffix="RB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabGUV" :data="tableData" tableName="guv"
                               :RowBKGFromSource="true"
                               edoClassName="rb"></StrukturBilanzTable>
        </v-tab-item>
        <v-tab-item value="tabSonstige">
          <StrukturBilanzTable configSuffix="RB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabSonstige" :data="tableData" tableName="aux"
                               :RowBKGFromSource="true"
                               edoClassName="rb"></StrukturBilanzTable>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
  </v-card>
</template>

<script>
import Vue from 'vue'
import StrukturBilanzTable from './StrukturBilanzTable'
import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'

export default {
  name: 'TabRohbilanz',
  components: {StrukturBilanzTable, BtnDownloadExcel},
  props: ['balance'],
  methods: {
    onChangeTab (item) {
      Vue.prototype.$api.debug('onChangeTab', item, this.lastTab)
      if (this.lastTab) {
        if (this.$refs[this.lastTab] && this.$refs[this.lastTab].close) {
          this.$refs[this.lastTab].close()
        }
      }
      if (this.$refs[item] && this.$refs[item].open) {
        this.$refs[item].open(this.tableData)
      }
      this.lastTab = item
    },
    close: function () {
      if (this.lastTab) {
        if (this.$refs[this.lastTab] && this.$refs[this.lastTab].close) {
          this.$refs[this.lastTab].close()
        }
      }
    },
    open: function (data) {
      Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
      this.reload()
    },
    onGetData: function (data) {
      this.tableData = _.clone(data)
      if (!this.lastTab) {
        this.lastTab = 'tabAktiva'
      }
      var cmp = this
      this.$nextTick(() => {
        cmp.showSelect = true
        if (cmp.$refs[cmp.lastTab]) {
          cmp.$refs[cmp.lastTab].open(cmp.tableData)
          Vue.prototype.$api.hideIdle()
          /*
          $('div[name=rbTabPanel]').find('a').css('position', 'static')
          $('div[name=rbTabPanel]').find('a').addClass('v-tabs__item--active')
          $('div[name=rbTabPanel]').find('.v-tabs__slider-wrapper').css('width', 70)
          */
        }
      })
    },
    reload: function () {
      Vue.prototype.$api.debug('reload', this.balance)
      Vue.prototype.$api.showIdle(Vue.i18n.translate('IDLE_MESSAGE_BIG_DATA'))
      Vue.prototype.$api.getRohbilanzDataWithBalance(this.balance, this.onGetData)
      /*
      if (this.tableData === null) {
      } else {
        this.$refs[this.tab2].open(this.tableData)
      }
       */
    }
  },
  data () {
    return {
      configExcel: {
        excelSheetStammdaten: 0,
        excelSheetStrukturbilanz: 0,
        excelSheetRohbilanz: 1,
        excelSheetKennzahlen: 0,
        excelSheetBilanzrating: 0,
        excelSheetKDF: 0,
        btnName: Vue.i18n.translate('DOWNLOAD_NAME_RB'),
        configName: '',
        type: 'EXCEL-STRUCT'
      },
      tableHeightSub: 160,
      tab2: null,
      tableData: null,
      lastTab: 'tabAktiva'
    }
  },
  mounted () {
    this.tab2 = 'tabAktiva'
    this.open()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabRohbilanz.vue